// src/js-dot/rx/functions/observerify.ts
import { from, Observable, of, throwError } from "rxjs";
import { isPromise } from "@js-dot/core";
function observify(target) {
  if (target instanceof Observable) {
    return target;
  }
  if (isPromise(target)) {
    return from(target);
  }
  if (typeof target === "function") {
    try {
      return of(target());
    } catch (reason) {
      return throwError(reason);
    }
  }
  return of(target);
}

// src/js-dot/rx/functions/combine-latests$.ts
import { combineLatestWith, map } from "rxjs";
import { debounceTime } from "rxjs/operators";
function combineLatests$(observables, debouncing = 24) {
  const first = observables[0];
  return observables.length > 1 ? first.pipe(combineLatestWith(...observables.slice(1)), debounceTime(debouncing)) : first.pipe(map(value => [value]));
}

// src/js-dot/rx/functions/check-subscription.ts
function checkSubscription(subscription, newSubscription) {
  if (subscription) {
    if (Array.isArray(subscription)) {
      let current = subscription.length;
      while (current-- > 0) {
        const subscription_ = subscription[current];
        if (subscription_ && typeof subscription["unsubscribe"] === "function") {
          subscription_.unsubscribe();
        }
      }
    } else {
      subscription.unsubscribe();
    }
  }
  return newSubscription || null;
}

// src/js-dot/rx/decorators/with-subject.ts
import { isObservable, takeWhile } from "rxjs";
function WithSubject(propertyName) {
  return function (target, propertyKey, descriptor) {
    const subscription = "@withSubjectSubscription_" + propertyKey;
    if (!descriptor) {
      let getRootSubject = function () {
          const subject = test(this[propertyName]);
          if (!this[subscription]) {
            this[subscription] = subject.pipe(takeWhile(() => {
              return this[propertyName] && !this[propertyName]?.closed;
            })).subscribe(value => {
              if (value !== void 0) {
                VALUE = value;
              }
            });
          }
          return subject;
        },
        rootSetter = function (value) {
          const subject = getRootSubject();
          VALUE = value;
          subject.next(value);
        },
        rootGetter = function () {
          getRootSubject();
          return VALUE;
        };
      let VALUE;
      return {
        set: rootSetter,
        get: rootGetter,
        enumerable: true,
        configurable: true
      };
    }
    const {
      set: originSetter,
      get: originGetter
    } = descriptor;
    function getSubject() {
      const subject = test(this[propertyName]);
      if (!this[subscription]) {
        if (this[propertyName] && !this[propertyName]?.closed) {
          subject.next(originGetter.call(this));
          this[subscription] = subject.pipe(takeWhile(() => {
            return this[propertyName] && !this[propertyName]?.closed;
          })).subscribe(value => {
            originSetter.call(this, value);
          });
        }
      }
      return subject;
    }
    function descriptorSetter(value) {
      const subject = getSubject.call(this);
      subject.next(originGetter.call(this));
    }
    function descriptorGetter() {
      getSubject.call(this);
      return originGetter.call(this);
    }
    descriptor.set = descriptorSetter;
    descriptor.get = descriptorGetter;
  };
  function test(subject) {
    if (!isObservable(subject) || typeof subject["next"] !== "function") {
      throw new ReferenceError(`${propertyName} is not a Subject or BehaviorSubject`);
    }
    return subject;
  }
}
export { WithSubject, checkSubscription, combineLatests$, observify };
